/**
 * Resolve a currency code from either an object {code,...} or a bare ISO string.
 */
const resolveCode = (currency) => {
  if (!currency) return 'USD';
  if (typeof currency === 'string') return currency;
  return currency.code || 'USD';
};

/**
 * Decimal places for a given currency code. OMR uses 3 fils, others use 2.
 */
export const decimalPlacesFor = (currency) => (resolveCode(currency) === 'OMR' ? 3 : 2);

/**
 * Format only the numeric portion of a price (no symbol, no currency icon).
 * Used by <PriceTag> when rendering an inline currency icon (e.g. OMR sign)
 * alongside the digits — the icon is composed in JSX, the digits come from here.
 *
 * @param {number|string} price
 * @param {object|string} currency  - currency object or ISO code
 * @returns {string} e.g. "14.990" for OMR, "14.99" otherwise
 */
export const formatAmount = (price, currency) => {
  const num = parseFloat(price);
  if (Number.isNaN(num)) return '0.00';
  return num.toFixed(decimalPlacesFor(currency));
};

/**
 * Format a price with currency symbol and position.
 * @param {number|string} price - The price value
 * @param {{ code?: string, symbol?: string, position?: string }|null} currency - Restaurant currency (code, symbol, position)
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, currency) => {
  if (!currency || !currency.symbol) {
    return `${parseFloat(price).toFixed(2)}`;
  }
  const symbol = currency.symbol;
  const position = currency.position || 'before';
  const formattedNumber = formatAmount(price, currency);

  if (position === 'before') {
    return `${symbol}${formattedNumber}`;
  }
  return `${formattedNumber} ${symbol}`;
};
